// extracted by mini-css-extract-plugin
export default {"mantralekhanFooter":"FooterWithLinks_mantralekhanFooter__IIxvm","socialIcon":"FooterWithLinks_socialIcon__HvCbn","playStoreLink":"FooterWithLinks_playStoreLink__kK08Z"};